import { render, staticRenderFns } from "./match.vue?vue&type=template&id=7412420c&scoped=true"
import script from "./match.vue?vue&type=script&lang=js"
export * from "./match.vue?vue&type=script&lang=js"
import style0 from "./match.vue?vue&type=style&index=0&id=7412420c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412420c",
  null
  
)

export default component.exports